/**
 * Market Melee — shared frontend constants.
 *
 * Only static game metadata goes here (card colors, asset logos, win thresholds).
 * Anything that touches game state belongs in `src/game/rules.js`.
 *
 * Keep this file in lock-step with /app/backend/app/data/card_data.py →
 * CRYPTO_INFO + ALL_CRYPTO_SYMBOLS. See /app/CARD_RULES_REFERENCE.md for the
 * full card catalogue.
 */

export const CRYPTO_INFO = {
  BTC:   { name: "Bitcoin",       color: "#F7931A" },
  ETH:   { name: "Ethereum",      color: "#627EEA" },
  ADA:   { name: "Cardano",       color: "#0033AD" },
  DOGE:  { name: "Dogecoin",      color: "#C2A633" },
  SOL:   { name: "Solana",        color: "#9945FF" },
  AVAX:  { name: "Avalanche",     color: "#E84142" },
  MATIC: { name: "Polygon",       color: "#8247E5" },
  NEAR:  { name: "NEAR Protocol", color: "#00C08B" },
  TON:   { name: "TON",           color: "#0098EA" },
};

export const ALL_CRYPTO_SYMBOLS = Object.keys(CRYPTO_INFO);

// Win thresholds — these are gameplay rules, keep in sync with backend.
export const CRYPTO_WIN_THRESHOLD = 1250;
export const MARKET_MELEE_LIMIT = 3;

// Card-back → theme color mapping. Populated from backend /api/card-backs.
export const DEFAULT_CARD_BACK_COLOR = "#1A237E";

// UI-only palette keyed by card subtype
export const SUBTYPE_COLORS = {
  action:       "#3B82F6",
  event:        "#F59E0B",
  market_melee: "#DC2626",
};

// Allowed in-game reactions. Must match the server allow-list in
// app/api/routes/games.py → post_reaction.
export const REACTIONS = ["🚀", "💀", "🤯", "😂", "🔥"];
